module.exports = __webpack_public_path__ + "img/dvrp_logo.6571f110.png";